export const DELIVERY_VALUES_ENUM = Object.freeze({
  deliver_now: 0,
  schedule_order: 1
})
